module.exports = __webpack_public_path__ + "static/media/image_6.f612f8cb.png";